import { faArrowDown, faArrowDownArrowUp, faArrowUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';

export interface ISortItemProps {
  sortField: string;
  sortBy?: string;
  onChange: (x: string) => void;
}

const IconColor = styled.div<{ isSortedByField: boolean }>`
  color: ${(props) => (props.isSortedByField ? props.theme.colors.black : props.theme.colors.darkGray)};
  cursor: pointer;
`;

export const SortItem: React.FC<ISortItemProps> = ({ sortField, sortBy, onChange }) => {
  const isSortedByField = (sortBy || '').startsWith(sortField);
  const isAsc = (sortBy || '').endsWith('asc');
  const icon = isSortedByField ? (isAsc ? faArrowUp : faArrowDown) : faArrowDownArrowUp;
  const onClick = () => {
    if (!isSortedByField || isAsc) {
      onChange(`${sortField}.desc`);
    } else {
      onChange(`${sortField}.asc`);
    }
  };
  return (
    <IconColor isSortedByField={isSortedByField}>
      <FontAwesomeIcon icon={icon} onClick={onClick} />
    </IconColor>
  );
};
